import type { AlertColor } from '@mui/material/Alert';

export type Season = {
	propertyId: string;
	seasonId: string;
	seasonName: string;
	seasonStartDate: Date | null;
	seasonEndDate: Date | null;
	selectedDays: string[];
	seasonPriority: number;
	highlightInMyView: boolean;
	lastUpdatedBy?: string;
	lastUpdatedDate?: Date;
};

export type InfoInput = {
	message: string;
	messageType: AlertColor;
};

export enum SeasonPriority {
	Lowest = 1,
	Low = 2,
	Medium = 3,
	High = 4,
	Highest = 5,
}
